import { computeMetrics } from '../top_ranker/statMetrics';

// 인식한 카드(캐릭터+무기)를 Top Ranker 통계 행에 연결한다.

// (캐릭터, 무기) 행을 찾는다. 그 무기 행이 없거나 무기를 못 읽었으면 그 캐릭터에서 가장 많이 쓰인 무기 행으로 추정한다.
export function findStat(stats, characterName, weaponName) {
  const ofCharacter = stats.filter((s) => s.characterName === characterName);
  if (!ofCharacter.length) {
    return { stat: null, weaponEstimated: false };
  }
  const exact = weaponName ? ofCharacter.find((s) => s.bestWeapon === weaponName) : null;
  if (exact) {
    return { stat: exact, weaponEstimated: false };
  }
  const mostUsed = ofCharacter.reduce((best, s) => (s.gameCount > best.gameCount ? s : best));
  return { stat: mostUsed, weaponEstimated: true };
}

// PiP에 그릴 카드 한 장의 표시용 값
export function buildCardView(card, stats, totalGameCount, averages) {
  const characterName = card.character.name;
  const { stat, weaponEstimated } = findStat(stats, characterName, card.weapon && card.weapon.name);
  return {
    characterName,
    weaponName: stat ? stat.bestWeapon : (card.weapon && card.weapon.name) || null,
    weaponEstimated,
    lowConfidence: !card.confident,
    stat,
    metrics: stat ? computeMetrics(stat, totalGameCount) : null,
    averages,
  };
}
